import template from './jobSimpleList.template.html';

export default {
  template,
  bindings: {
    onFinished: '&',
    idTicket: '<',
    timeStamp: '<',
    status: '<',
    onChange: '&'
  },
  controller: class controller {
    constructor(
      $q,
      dateTimeService,
      assetFinanceService,
      workflowService,
      accountsService,
      authenticationService,
      ticketService,
      homeLoanService,
      jobsService,
      $rootScope,
      ACCOUNT
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.productJobs = [];
      ctrl.statusSupported = ['settled', 'post_commissions', 'paused'];

      ctrl.initialize = async () => {
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        const date = dateTimeService.setDate(
          moment.utc().tz(ctrl.currentTimeZone).startOf('day'),
          ctrl.currentTimeZone
        );
        const absoluteDueDate = parseInt(moment.utc(date).format('X') || 0, 10);
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.timeStamp = ctrl.timeStamp || absoluteDueDate;
        ctrl.status = ctrl.status || null;
        if (!ctrl.statusSupported.includes(ctrl.status)) {
          return;
        }
        if (ctrl.idTicket) {
          ctrl.ticket = await ticketService.readTicket({ id: ctrl.idTicket });
          ctrl.isBroker = authenticationService.isBroker(ctrl.ticket.idOwner);
          const [workflow, accounts] = await $q.all([
            workflowService.readWorkflow({ id: ctrl.ticket.idWorkflow }),
            accountsService.getAvailable({
              isActive: true,
              fields: ACCOUNT.FIELDS.LIST
            })
          ]);
          ctrl.workflow = workflow;
          ctrl.accounts = _.filter(
            accounts,
            (account) => ctrl.workflow.idTeamMembers.indexOf(account.id) > -1
          );
          ctrl.stage = ctrl.workflow.stages.find((s) => s.id === ctrl.ticket.idStage);

          if (ctrl.status === 'paused') {
            ctrl.productJobs = jobsService.generateStatusChangeJobsFor('paused', {
              ticket: ctrl.ticket,
              timeStamp: ctrl.timeStamp
            });

            return;
          }

          if (ctrl.workflow.isAssetFinance()) {
            ctrl.loan = await assetFinanceService.readAssetFinance({
              id: ctrl.ticket.idAssetFinance
            });
            ctrl.productJobs = jobsService.generatePostSettlementJobListAssetFinance(
              ctrl.loan,
              ctrl.ticket,
              ctrl.timeStamp
            );
          }
          if (ctrl.workflow.isHomeLoan()) {
            if (ctrl.ticket.idLoan && $rootScope.hasBrokerToolsEnabled() && ctrl.isBroker) {
              ctrl.loan = await homeLoanService.readHomeLoan({ id: ctrl.ticket.idLoan });
              ctrl.productJobs = jobsService.generatePostSettlementJobListBrokerTools(
                ctrl.loan,
                ctrl.ticket,
                ctrl.timeStamp
              );
            } else {
              ctrl.productJobs = jobsService.generatePostSettlementJobList(
                ctrl.ticket,
                ctrl.timeStamp
              );
            }
          }
        }
      };

      ctrl.hasAnyJobs = () => _.some(ctrl.productJobs, (product) => product?.jobs?.length);

      ctrl.onChangeJob = () => {
        const jobsToCreate = _.chain(ctrl.productJobs)
          .map((productJobs) => productJobs.jobs)
          .flatten()
          .filter(({ isActive }) => isActive)
          .value();

        ctrl.onChange({ jobsToCreate });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
